import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Activity, ActivitySerializer} from '@edward-software/edw-fwk-angular-lib/models';
import {EntityService} from '../entity.service';

@Injectable({
    providedIn: 'root'
})
export class ActivityService extends EntityService<Activity> {

    constructor(private http: HttpClient) {
        super(
            http,
            JSON.parse(localStorage.getItem('ENV_CONFIG')).apiScheduleUrl,
            'activities',
            new ActivitySerializer()
        );
    }
}
